import mitt, { Emitter } from 'mitt';
import {Events as FeaturesEvents} from 'features/configs/eventBus';

// Define the event types
type MainEvents = {
    API_RESPONSE_ERROR: any,
    OPEN_SEARCH_DIALOG: any
};

type EventAlls = MainEvents & FeaturesEvents ;// & FeatureBEvents;

// Create a typed emitter
const eventBus: Emitter<EventAlls> = mitt<EventAlls>();

// Export the emitter
export { eventBus };

// Export the event types
export type { EventAlls };
